import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface PhysicalCardTooltipProps {
  openLeft: boolean
}

const PhysicalCardTooltip: React.FC<PhysicalCardTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {translate(
          '${physicalCards} are exact replicates of a Virtual Card and provide users with a payment method that can be used at point of sale. Physical cards can only be created at the time you create the Virtual Card and any changes you make to your Virtual Card will immediately be reflected on your physical card, including deactivation.',
          {
            physicalCards: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Physical cards')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default PhysicalCardTooltip
